import { render } from "./AppHomeHeader.vue?vue&type=template&id=ea4c7358"
import script from "./AppHomeHeader.vue?vue&type=script&lang=js"
export * from "./AppHomeHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/majstro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__